// Module
var code = "You should now try to find a bridge, ideally over some water, or just by a waterfront is ok too. <br> Press ‘I’m there’ when you are.";
// Exports
module.exports = code;